<script setup>
import LaisTabs from 'dashboard/components-next/LaisTabs.vue';

defineProps({
  tabs: { type: Array, required: true },
  modelValue: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue', 'change']);
const TABS_ARIA_LABEL = 'Seções do financeiro';

const updateValue = value => {
  emit('update:modelValue', value);
};

const changeTab = value => {
  emit('change', value);
};
</script>

<template>
  <div class="flex-1 overflow-auto p-4 sm:p-6 lg:p-10">
    <LaisTabs
      :model-value="modelValue"
      :tabs="tabs"
      :aria-label="TABS_ARIA_LABEL"
      @update:model-value="updateValue"
      @change="changeTab"
    >
      <template v-for="item in tabs" #[item.id]="slotProps" :key="item.id">
        <slot :name="item.id" v-bind="slotProps" />
      </template>
      <template #panel="slotProps">
        <slot name="panel" v-bind="slotProps" />
      </template>
    </LaisTabs>
    <slot />
  </div>
</template>
